export default __webpack_public_path__ + "images/challenges_it-security.jpg";